import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

function RutaPrivada({ allowedRoles }) {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  let decoded;
  try {
    decoded = jwtDecode(token);
  } catch {
    return <Navigate to="/login" replace />;
  }

  // 👉 Rol EXACTO desde BD, solo normalizamos para comparar
  const role = decoded.role?.trim().toLowerCase();

  // 👉 Roles permitidos vienen escritos como en BD
  const rolesPermitidos = allowedRoles.map(r =>
    r.trim().toLowerCase()
  );

  if (!role || !rolesPermitidos.includes(role)) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}

export default RutaPrivada;
